<app-content-header text="Credit Card Details"></app-content-header>
<app-payment-details-form
  #paymentDetailsForm
  [paymentId]="paymentCreditCardId"
  [isEditMode]="isEditMode"
  (submittedInSuccess)="submittedInSuccess($event)"
  (submittedInFailure)="submittedInFailure($event)"
></app-payment-details-form>

<div style="margin-top: 1rem;">
  <hr>
  <footer class="flex-sm-row flex-column-reverse row no-gutters footer-action div-footer">
    <div class="col pr-sm-1">
      <button
        class="btn btn-outline-danger btn-block"
        (click)="onCancel()"
      >Cancel</button>
    </div>
    <div class="col pl-sm-1">
      <button
        noDoubleClick
        class="btn btn-danger btn-block mb-2 mb-sm-0"
        [ngClass]="{'disabled-btn': !paymentDetailsFormComponent?.form?.valid}"
        [disabled]="!paymentDetailsFormComponent?.form?.valid"
        (debounceClick)="onSave()"
      >Save</button>
    </div>
  </footer>
</div>
